<script lang="ts">
import { defineComponent } from "vue";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";
import { apiService } from "@/services/services";
import PromiseWrapper from "@/shared/components/PromiseWrapper.vue";
import { Infos } from "@/models/infos.model";
import LoadingOverlay from "@/shared/components/LoadingOverlay.vue";
import { cloneDeep, isEqual } from "lodash";

export default defineComponent({
  components: { LoadingOverlay, PromiseWrapper, KlereoBanner },
  data() {
    return {
      saving: false,
      promise: undefined as Promise<unknown> | undefined,
      savedInfos: {} as Infos,
      infos: {} as Infos,
      values: {},
      fields: [
        { name: "email", label: "Email", disabled: true },
        { name: "lastName", label: "FName", disabled: false },
        { name: "firstName", label: "Name", disabled: false },
        { name: "street", label: "Addr", disabled: false },
        { name: "zipcode", label: "Zip", disabled: false },
        { name: "city", label: "City", disabled: false },
        { name: "country", label: "Country", disabled: false },
      ] as const,
    };
  },
  methods: {
    async onSubmit() {
      this.saving = true;
      const infos = await apiService.setInfos({
        address: this.infos.street,
        city: this.infos.city,
        country: this.infos.country,
        firstName: this.infos.firstName,
        lastName: this.infos.lastName,
        zipCode: this.infos.zipcode,
      });
      this.saving = false;
      this.savedInfos = this.infos;
    },
  },
  created() {
    this.promise = apiService.getInfos().then((infos) => {
      this.savedInfos = infos;
    });
  },
  watch: {
    savedInfos() {
      console.log("cloning");
      this.infos = cloneDeep(this.savedInfos);
    },
  },
  computed: {
    isDirty() {
      return !isEqual(this.savedInfos, this.infos);
    },
  },
});
</script>

<template>
  <promise-wrapper :promise="promise">
    <loading-overlay :loading="saving" />
    <form @submit.prevent="onSubmit">
      <div v-for="field in fields" :key="field.name" class="mb-5">
        <label class="block form-label" :for="field.name">{{
          $t(field.label)
        }}</label>
        <input
          class="form-input"
          v-model="infos[field.name]"
          :disabled="field.disabled"
          :id="field.name"
          type="text"
        />
      </div>

      <div class="text-right mt-5">
        <button type="submit" class="btn--primary" :disabled="!isDirty">
          {{ $t("Valid") }}
        </button>
      </div>
    </form>
  </promise-wrapper>
</template>
